import React,{useState} from 'react'
import {Container,Button, Form, FormGroup, Label, Input} from 'reactstrap'
import './manualSurvey.css'
const ManualSurvey = (props) => {

let [question,setQuestion] = useState(0)
let questionIndex = props.json.questions.findIndex(x => x.volgordePos === question)
let [text,setText] = useState('')
let [history,setHistory] = useState([{fromQuestion: "", toQuestion: "" }])
let [previousQuestionPos,setPreviousQuestionPos] = useState('')
let omschrijving,questionId,typeObject,volgordePos,answers
props.json.questions[questionIndex] ? omschrijving=props.json.questions[questionIndex].title:omschrijving=''
props.json.questions[questionIndex] ? questionId=props.json.questions[questionIndex].name:questionId=''
props.json.questions[questionIndex] ? typeObject=props.json.questions[questionIndex].type:typeObject='completed'
props.json.questions[questionIndex] ? volgordePos = props.json.questions[questionIndex].volgordePos:volgordePos=""
props.json.questions[questionIndex] ? answers = props.json.questions[questionIndex].choices :answers=''
const [fieldValues,setFieldValues] = useState([{id: "", value: "" , isOpenText:false}])
const [next,setNext]= useState('')
const lastQuestion = props.json.questions[props.json.questions.length - 1]
//console.log('fieldValues',fieldValues)

const setAnswer = answer => {
    let toAdjustorNot = fieldValues.findIndex(x => x.id === questionId)
    let adjust = (toAdjustorNot!==-1) ? true : false
    let values={
        id:questionId,
        value:answer.value,
        isOpenText:false
    }
    adjust ? setFieldValues(
        fieldValues.map(fieldValue => (
            
            fieldValue.id===questionId ? values:fieldValue
        )
        )
        
    )
    :
    setFieldValues(fieldValues => [...fieldValues,{id:questionId,value:answer.value,isOpenText:false}])
    setNext(answer.volgende)
}


const completeSurvey = () => {
    if (typeObject==="TextBox") if (!text) return
    let sort=''
    typeObject="TextBox" ? sort = true:false
    fieldValues.push({'id':questionId,'value':text,isOpenText:sort})
    let notparticipate=false
    if (previousQuestionPos ===1) notparticipate=true
    props.onComplete(fieldValues,notparticipate)
    setQuestion('finished')
}
const nextQuestion = (volgendBijGeenAntwoord) => {
    
    setPreviousQuestionPos(volgordePos)
    let volgendeVraag=""
    if (next) volgendeVraag = next
    if (volgendBijGeenAntwoord) volgendeVraag = volgendBijGeenAntwoord 
    if (volgordePos === 1 && volgendeVraag === lastQuestion.volgordePos) {
        setQuestion('finished')
        props.onComplete(fieldValues,true)
        return
    }
    //anwers indien niet op geklikt
    let index=fieldValues.findIndex(x => x.id === questionId)
    let checkedValue = (index!==-1) ? fieldValues[index].value : false
    //console.log('checkedValue',checkedValue)
   //console.log('typeObject',typeObject)
    if (checkedValue) { 
    answers.map(answer => {
      if (answer.value == checkedValue) setNext(answer.volgende)
    })}
    
    if (typeObject==="RadioButtons" && !checkedValue) return
    if (typeObject==="TextBox") if (!text) return

    volgendBijGeenAntwoord ? setHistory(history => [...history,{fromQuestion:volgordePos,toQuestion:volgendBijGeenAntwoord}]):setHistory(history => [...history,{fromQuestion:volgordePos,toQuestion:next}]) 
    volgendBijGeenAntwoord ? setQuestion(volgendBijGeenAntwoord) : setQuestion(next)
   
    //haal indexwaarde van die vraag op uit questions
    let questionIndexn = props.json.questions.findIndex(x => x.volgordePos === volgendeVraag)
    //Bepaal de questionId om de juiste waarde uit fieldValues op te halen
    
    let questionIdn=props.json.questions[questionIndexn].name
    let indexFieldVal = fieldValues.findIndex(x => x.id === questionIdn)
    let adjust = (indexFieldVal!==-1) ? true : false
    adjust ? setText(fieldValues[indexFieldVal].value) :setText('')

    setNext('')
   
 }
const previousQuestion = () => {
    
    //zoek vorige vraag op in de historie
    let index = history.findIndex(x => x.toQuestion === volgordePos) 
    setQuestion(history[index].fromQuestion)
    //haal indexwaarde van die vraag op uit questions
    let questionIndexp = props.json.questions.findIndex(x => x.volgordePos === history[index].fromQuestion)
    //Bepaal de questionId om de juiste waarde uit fieldValues op te halen
    let questionIdp = props.json.questions[questionIndexp].name
    //Zoek de bijbehorende index uit fieldValues
    let indexVal = fieldValues.findIndex(x => x.id === questionIdp)
    //Zet het textattribuut gelijk aan de waarde van fieldValues
     if (indexVal!==-1) {
    setText(fieldValues[indexVal].value)
    props.json.questions[questionIndexp].choices.map(answer => {
      if (answer.value == fieldValues[indexVal].value) setNext(answer.volgende)
    })
}

   //verwijder alle entries vanaf hier uit de geschiedenis
    let verwijderItem = history.splice(index)  
    let verwijderValues = fieldValues.splice(index) 
}
const setTextField = () => {
    let index = fieldValues.findIndex(x => x.id === questionId)
    let adjust = (index!==-1) ? true : false
    let values={
        id:questionId,
        value:text
    }
   adjust ? setFieldValues(   
    fieldValues.map(fieldValue => (
            fieldValue.id===questionId ? values:fieldValue
        )
      )
    )
    :
    setFieldValues(fieldValues => [...fieldValues,{id:questionId,value:text,text,isOpenText:true}])
    }   

const contentStyle = {
    color:props.json.color
}

const floatRight = {
    float:"Right"
}

const RadioAnswers = () =>{  
    
    
    let index=fieldValues.findIndex(x => x.id === questionId)
    let checkedValue = (index!==-1) ? fieldValues[index].value : false
 
    return (
      answers.map((answer) => (
     <div>            
        <FormGroup check>
        <Input 
        type="radio" 
        name={questionId} 
        onClick={() => setAnswer(answer) } 
        checked={answer.value === checkedValue}
        required
        />
        
        <Label >{answer.text}</Label>
        </FormGroup>
        </div>
        ))
    )}

const TextBox = () =>{  
    return (
        <div>
        <Input 
        type="textarea" 
        name={questionId} 
        value={text}
        onChange={event => setText(event.target.value)}
        required
        />
        </div>
        ) }
 if (typeObject === "HTML") {
    return (
        <Container>
        
        <div style={contentStyle}
        dangerouslySetInnerHTML={{
          __html: omschrijving
        }}></div>
     <div className="buttonRow">
    <Button  name={questionId} onClick={() => {setNext(1);nextQuestion(1)}}>Volgende</Button>
    </div>
   
    </Container>
    )}
if (typeObject === "RadioButtons") {
     return (
    <Container>
    <div style={contentStyle}>
    <Form>
    <h5>{omschrijving}</h5>
    {RadioAnswers()}
    <div className="buttonRow">
    <Button color="success" name={questionId} onClick={() => previousQuestion()}>Vorige</Button>
    {' '}
    {volgordePos!==lastQuestion.volgordePos?
    <Button color="success" style={floatRight}  name={questionId} onClick={() => nextQuestion()}>Volgende</Button>
     :<Button color="success" style={floatRight} name={questionId} onClick={() => {completeSurvey()}}>Afronden</Button>
    }
    </div>
    </Form>   
    </div>
    </Container>
)}
if (typeObject === "TextBox") {
    let volgend=volgordePos+1
    if (answers[0]) {
        volgend=answers[0].volgende 
    }
    return (
    <Container>
    <div style={contentStyle}>
    <h5>{omschrijving}</h5>
    {TextBox()}
    <br></br>
    <div className="buttonRow">
    <Button color="success" name={questionId} onClick={() => previousQuestion()}>Vorige</Button>
    {' '}
    {volgordePos!==lastQuestion.volgordePos?
    <Button color="success" style={floatRight} name={questionId} onClick={() => {setTextField();setNext(volgend);nextQuestion(volgend)}}>Volgende</Button>
    :<Button color="success" style={floatRight} name={questionId} onClick={() => {completeSurvey()}}>Afronden</Button>
    }
    </div>
   </div>
   </Container>
)}               

if (typeObject === "completed") {
    return (
    <Container>
    <div style={contentStyle}>  
    <h5>{props.json.completed}</h5>
   </div>
   </Container>
)}       


    }

export default ManualSurvey